export default __webpack_public_path__ + "static/media/ferruccio-de-bortoli.5d60adfe.png";